import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=04fe26e4"
import script from "./NewTemplate.vue?vue&type=script&lang=js"
export * from "./NewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=04fe26e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports